import { IconButton, Tooltip } from '@mui/material'
import LightModeOutlined from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined'

import { useThemeMode } from './ThemeModeProvider'

/**
 * The control that makes dark mode reachable.
 *
 * The theme has shipped both modes since Phase 1, and `useThemeMode` / `toggleMode` existed
 * — with zero consumers anywhere outside src/theme. So "dark available" was true of the
 * token layer and false of the product: the only way in was editing localStorage by hand.
 *
 * The icon shows the mode you will GET, not the one you are in, and the label says so —
 * an unlabelled sun/moon is ambiguous in exactly the way a toggle must not be.
 */
const ThemeModeToggle = () => {
  const { mode, toggleMode } = useThemeMode()
  const next = mode === 'dark' ? 'light' : 'dark'
  const label = `Switch to ${next} mode`

  return (
    <Tooltip title={label}>
      <IconButton onClick={toggleMode} aria-label={label} size='small'>
        {mode === 'dark'
          ? <LightModeOutlined sx={{ fontSize: 18 }} />
          : <DarkModeOutlined sx={{ fontSize: 18 }} />}
      </IconButton>
    </Tooltip>
  )
}

export default ThemeModeToggle
